function FrameEventClient() {
    var self = this;
    var functions = {};

    function bindEvent(element, eventName, eventHandler) {
        if (element.addEventListener) {
            element.addEventListener(eventName, eventHandler, false);
        } else if (element.attachEvent) {
            element.attachEvent('on' + eventName, eventHandler);
        }
    }

    bindEvent(window, 'message', function (e) {
        let methodName = e.data.name && e.data.name.toLowerCase()
        var method = functions[methodName];
        method && method(e.data);
    });


    this.listen = function (evt, cb) {
        let found = functions[evt.toLowerCase()];
        if (found) new Error("El evento '" + evt.toLowerCase() + "' ya ha sido definido");
        functions[evt.toLowerCase()] = cb;
    }

    this.sendEvent = function (frame, evt, data) {
        let eventObject = {
            name: evt,
            data: data
        };
        var objIframe = frame;
        if (typeof frame == 'string') {
            objIframe = document.getElementById(frame);
        }
        eventObject.frame = objIframe.name;
        objIframe.contentWindow && objIframe.contentWindow.postMessage(eventObject, '*');
    }
}

window.frameEventClient = new FrameEventClient();


// WEBPACK FOOTER //
// ./Statics/scripts/common/frame-event.js